module.exports = __webpack_public_path__ + "images/scandinavian-1-0507aaf0f54f2abe56a4615cbd6f6710.jpg";